import { formatUtils } from '@makemydeal/dr-common-utils';

export const TRADE_IN_EMPTY_VALUE = '--';

export const formatTradeInMileage = (mileage?: number, emptyValue: string = TRADE_IN_EMPTY_VALUE): string =>
    mileage === undefined ? emptyValue : formatUtils.formatNumber(mileage);

export const formatTradeInAmount = (amount?: number, emptyValue: string = TRADE_IN_EMPTY_VALUE): string =>
    amount === undefined ? emptyValue : formatUtils.formatDollars(amount);
